import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorService } from '../../services/error.service';
import { RouteTrackingService } from '../../services/route-tracking.service';
import { DateTimeService } from '../../services/date-time.service';
import { CustomerService } from '../../services/customer.service';
import { AppService } from '../../services/app.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
	selector: 'app-receipt',
	templateUrl: './receipt.html',
	styleUrls: ['./receipt.scss']
})
export class ReceiptComponent implements OnInit, OnDestroy {
	@Input() public id: any;
	@Input() public shipmentType: string;
	@Input() public hideStatusCodes: boolean;
	@Input() public hideParcelInfo: boolean;
	@Input() public hideRating: boolean;
	@Input() public hideSignature: boolean;
	@Input() public hideDestinationAddress: boolean;
	@Input() public hideOriginAddress: boolean;
	@Input() public mode: string;
	@Input() public bulkReportData: any;
	public order: any;
	public receiptDetails: any;
	public companyLogo: string;
	public user: User = new User();
	public selectedCustomer: any;
	public dateTimeFormat: any;
	public userSubscription: any;
	public logoSubscription: any;
	public bulkReceipts : any;

	constructor(private _orderService: OrderService,
				private _userService: UserService,
				private _sanitizer: DomSanitizer,
				private _errorService: ErrorService,
				private _routeTrackingService: RouteTrackingService,
				private _dateTimeService: DateTimeService,
				private _customerService: CustomerService,
				private _appService: AppService,
				private _spinnerService: SpinnerService) {
		this.receiptDetails = {
			captions: {},
			order: {}
		};
	}

	ngOnInit() {
		this.selectedCustomer = this._customerService.getSelectedCustomer();
		this.userSubscription = this._userService.user$.subscribe((data) => {
			this.user = data;
		});
		this.logoSubscription = this._appService.companyLogo$.subscribe(response => {
			this.companyLogo = response;
		});

		if (!this.mode || this.mode === 'single') {
			this.printSingleReceipt();
		}
		else if (this.mode === 'multiple') {
			this.printMultipleReceipts();
		}
	}

	printMultipleReceipts(): void {
		this._spinnerService.startSpinner();
		
		this._orderService.getGeneralReportReceipt(
			this.bulkReportData.customerId,
			this.bulkReportData.beginDate,
			this.bulkReportData.endDate,
			this.bulkReportData.quantity,
			this.bulkReportData.filterField,
			this.bulkReportData.filterType,
			this.bulkReportData.filterText
		).subscribe(
			(response) => {
			this.bulkReceipts = response;
			// Prepare receipt data with necessary attributes
			this.bulkReceipts.forEach(receipt => {
			  // Process signature if available
			  if (receipt.order && receipt.order.proofOfDelivery && receipt.order.proofOfDelivery.base64EncodedSignature) {
				// Using DomSanitizer would be ideal, but we'll handle it differently due to iteration context
				receipt.order.proofOfDelivery.base64EncodedSignature = this._sanitizer.bypassSecurityTrustUrl('data:image/svg+xml;base64,' + receipt.order.proofOfDelivery.base64EncodedSignature);
			  }
			  
			  // Calculate parcel totals if needed
			  if (receipt.order && receipt.order.parcels && receipt.order.parcels.length > 0) {
				this.calcTotals(receipt.order.parcels);
			  }
			});
			
			this._spinnerService.stopSpinner();
		  },
		  (error) => {
			this._errorService.error(error, 'getGeneralReportReceipt Failed', 'modal');
			this._spinnerService.stopSpinner();
		  }
		);
	}

	private printSingleReceipt() {
		if (this.id && this.shipmentType === 'OnDemand') {
			this._orderService.getReceipt(this.id).subscribe((response) => {
				this.receiptDetails = response;
				if (this.receiptDetails.order.proofOfDelivery.base64EncodedSignature) {
					this.receiptDetails.order.proofOfDelivery.base64EncodedSignature = this._sanitizer.bypassSecurityTrustUrl('data:image/svg+xml;base64,' + this.receiptDetails.order.proofOfDelivery.base64EncodedSignature);
				}
				if (this.receiptDetails.order.parcels && this.receiptDetails.order.parcels.length > 0) {
					this.calcTotals(this.receiptDetails.order.parcels);
				}
			}, (error) => {
				this._errorService.error(error, 'getOrderById Failed', 'modal');
			});
		} else {
			this._routeTrackingService.getReceipt(this.id).subscribe((response: any) => {
				this.receiptDetails.order = response.routeStop;
				this.receiptDetails.captions = response.captions;
				if (this.receiptDetails.order.proofOfDelivery.base64EncodedSignature) {
					this.receiptDetails.order.proofOfDelivery.base64EncodedSignature = this._sanitizer.bypassSecurityTrustUrl('data:image/svg+xml;base64,' + response.routeStop.proofOfDelivery.base64EncodedSignature);
				}
				if (this.receiptDetails.order.parcels && this.receiptDetails.order.parcels.length > 0) {
					this.calcTotals(this.receiptDetails.order.parcels);
				}
			}, (error) => {
				this._errorService.error(true, error, 'getRouteStopDetail Failed');
			});
		}
		this.dateTimeFormat = this._dateTimeService.getDateTime();
	}

	ngOnDestroy() {
		if (this.userSubscription) {
			this.userSubscription.unsubscribe();
		}

		if (this.logoSubscription) {
			this.logoSubscription.unsubscribe();
		}
	}

	calcTotals(parcels) {
		parcels.forEach((parcel) => {
			parcel.assignments.forEach((assignment) => {
				let total = 0;
				if (assignment.items) {
					assignment.items.forEach((item) => total = total + item.quantity);
				}
				assignment.itemTotal = total;
			});
		})
		
	}
}
